/**
 * Loading spinner component
 */

import './LoadingSpinner.css';

/**
 * Loading spinner with optional full screen mode
 * @param {Object} props - Component props
 * @param {boolean} props.fullScreen - Display full screen centered
 * @param {string} props.size - Spinner size (sm, md, lg)
 * @param {string} props.message - Optional loading message
 * @returns {React.ReactElement} Spinner element
 */
export default function LoadingSpinner({
  fullScreen = false,
  size = 'md',
  message
}) {
  const spinner = (
    <div className={`spinner spinner--${size}`} role="status" aria-label="Loading">
      <div className="spinner__circle" />
      {message && <p className="spinner__message">{message}</p>}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="spinner-overlay">
        {spinner}
      </div>
    );
  }

  return spinner;
}
